
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use hardcoded values directly to ensure consistency across environments
const SUPABASE_URL = "https://gzpwtfibehrrbwxnmvms.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd6cHd0ZmliZWhycmJ3eG5tdm1zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5OTQ1NjUsImV4cCI6MjA2MDU3MDU2NX0.Gv11UFr58Ae1kw5jD-82sXNXWgPDcC9IrkK0K29vxFQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
